export function isAllotmentBlockCode(code) {
    // Regex testing if length is 7, the first letter is 'b' and the other 6 are numbers
    // In this case send allotment_block_code instead of promo
    const allotmentBlockRegex = /^b\d{6}$/;
    return allotmentBlockRegex.test((code || '').trim());
}
export function getSplitPromoAndAllotmentBlockCode(code) {
    const codeTrimmed = code === null || code === void 0 ? void 0 : code.trim();
    if (isAllotmentBlockCode(codeTrimmed)) {
        return {
            allotmentBlockCode: codeTrimmed,
            promo: undefined,
        };
    }
    return {
        allotmentBlockCode: undefined,
        promo: codeTrimmed,
    };
}
